const ErrorHandler = () => {
  return <></>;
};

export default ErrorHandler;
